import React, { useEffect } from "react";
import { Card, Container, Form, Button, Row, Col } from "react-bootstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useToasts } from "react-toast-notifications";
import Backdrop from "../../Components/UI/Backdrop/Backdrop";
import { useDispatch, useSelector } from "react-redux";
import InputMask from "react-input-mask";

import { startAuth } from "../../Store/actions/index";
import { useHistory } from "react-router";

export default function Rigster() {
  const dispatch = useDispatch();
  const router = useHistory();
  const { error, verfiyAfterSignUp } = useSelector((state) => state.Auth);
  const { addToast } = useToasts();
  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      password: "",
      confirmPassword: "",
      ssm_number: "",
      company_name: "",
      phone: "",
      dealership_type: "",
      line_1: "",
      line_2: "",
      postcode: "",
      area: "",
      state: "",
      country: "",
    },
    validationSchema: Yup.object().shape({
      name: Yup.string()
        .max(100, "name must be less than 100 characters")
        .required("name is required"),
      email: Yup.string()
        .email("Must be a valid email address")
        .max(100, "email must be less than 100 characters")
        .required("email is required"),
      password: Yup.string()
        .max(100, "password must be less than 100 characters")
        .required("password is required"),
      confirmPassword: Yup.string()
        .oneOf([Yup.ref("password"), null], "passwords must match")
        .required("password is required"),
      ssm_number: Yup.string()
        .max(100, "must be less than 100 characters")
        .when("dealership_type", {
          is: "Company",
          then: Yup.string().required("ssm number is required"),
        }),
      company_name: Yup.string()
        .max(100, "must be less than 100 characters")
        .when("dealership_type", {
          is: "Company",
          then: Yup.string().required("company name is required"),
        }),
      phone: Yup.string()
        .max(100, "must be less than 100 characters")
        .required("phone is required"),
      dealership_type: Yup.string()
        .max(100, "must be less than 100 characters")
        .required("dealership type is required"),
      line_1: Yup.string()
        .max(100, "must be less than 100 characters")
        .required("line 1 is required"),
      line_2: Yup.string()
        .max(100, "must be less than 100 characters")
        .required("line 2 isrequired"),
      postcode: Yup.number()
        .integer()
        .positive()
        .required("postcode is required"),
      area: Yup.string()
        .max(100, "must be less than 100 characters")
        .required("area is required"),
      state: Yup.string()
        .max(100, "must be less than 100 characters")
        .required("state is required"),
      country: Yup.string()
        .max(100, "must be less than 100 characters")
        .required("country is required"),
    }),
    onSubmit: (values) => {
      dispatch(startAuth(values.email, values.password, "signUp", values));
    },
  });

  const { setFieldError } = formik;

  useEffect(() => {
    if (error) {
      addToast(error, { appearance: "error", autoDismiss: true });
      if (error.includes("mail")) setFieldError("email", error);
      else if (error.includes("password")) setFieldError("password", error);
      window.scroll({
        top: 90,
        behavior: "smooth",
      });
    }
  }, [error, setFieldError, addToast]);

  useEffect(() => {
    if (verfiyAfterSignUp) {
      addToast(verfiyAfterSignUp, { appearance: "warning", autoDismiss: true });
      dispatch({
        type: "VERIFI_AFTER_SIGN_UP",
        verfiyAfterSignUp: null,
        loadingAuth: null,
      });
      router.push("/");
    }
  }, [verfiyAfterSignUp, addToast, dispatch, router]);
  return (
    <Container
      className="continer-background"
      fluid
      data-aos="fade-down"
      data-aos-duration="800"
      data-aos-delay="200"
    >
      <Row className="py-5 mx-auto">
        <Col md={{ span: 6, offset: 3 }}>
          <Card style={{ zIndex: "1000" }} className="border-0 bg-transparent">
            <Form
              noValidate
              onSubmit={formik.handleSubmit}
              data-aos="fade-up"
              data-aos-duration="800"
              data-aos-delay="500"
            >
              <Form.Group className="my-3">
                <Form.Label className="fw-bolder mb-0 lh-1 text-dark">
                  Name <sup>*</sup>
                </Form.Label>
                <Form.Control
                  name="name"
                  type="text"
                  placeholder="John Doh"
                  isInvalid={formik.touched.name && formik.errors.name}
                  {...formik.getFieldProps("name")}
                />
                <Form.Control.Feedback
                  type="invalid"
                  className="text-end text-light"
                >
                  {" "}
                  {formik.errors.name}
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="my-3">
                <Form.Label className="fw-bolder mb-0 lh-1 text-dark">
                  Email <sup>*</sup>
                </Form.Label>
                <Form.Control
                  name="email"
                  type="text"
                  placeholder="John Doh"
                  isInvalid={formik.touched.email && formik.errors.email}
                  {...formik.getFieldProps("email")}
                />
                <Form.Control.Feedback
                  type="invalid"
                  className="text-end text-light"
                >
                  {" "}
                  {formik.errors.email}
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="my-3">
                <Form.Label className="fw-bolder mb-0 lh-1 text-dark">
                  Password <sup>*</sup>
                </Form.Label>
                <Form.Control
                  type="password"
                  name="password"
                  placeholder="Password"
                  isInvalid={formik.touched.password && formik.errors.password}
                  {...formik.getFieldProps("password")}
                />
                <Form.Control.Feedback
                  type="invalid"
                  className="text-end text-light"
                >
                  {formik.errors.password}
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="my-3">
                <Form.Label className="fw-bolder mb-0 lh-1 text-dark">
                  Confirm Password <sup>*</sup>
                </Form.Label>
                <Form.Control
                  type="password"
                  name="confirmPassword"
                  placeholder="Confirm Password"
                  isInvalid={
                    formik.touched.confirmPassword &&
                    formik.errors.confirmPassword
                  }
                  {...formik.getFieldProps("confirmPassword")}
                />
                <Form.Control.Feedback
                  type="invalid"
                  className="text-end text-light"
                >
                  {formik.errors.confirmPassword}
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="my-3">
                <Form.Label className="fw-bolder mb-0 lh-1 text-dark">
                  Dealership Type<sup>*</sup>
                </Form.Label>
                <Form.Control
                  as="select"
                  name="dealership_type"
                  isInvalid={
                    formik.touched.dealership_type &&
                    formik.errors.dealership_type
                  }
                  {...formik.getFieldProps("dealership_type")}
                >
                  <option hidden value="">
                    Select type
                  </option>
                  <option value="Private">Private</option>
                  <option value="Company">Company</option>
                </Form.Control>
                <Form.Control.Feedback
                  type="invalid"
                  className="text-end text-light"
                >
                  {formik.errors.dealership_type}
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="my-3">
                <Form.Label className="fw-bolder mb-0 lh-1 text-dark">
                  SSM Number{" "}
                  {formik.values.dealership_type === "Company" && <sup>*</sup>}
                </Form.Label>
                <Form.Control
                  type="text"
                  name="ssm_number"
                  placeholder="1232143-Kb"
                  isInvalid={
                    formik.touched.ssm_number && formik.errors.ssm_number
                  }
                  {...formik.getFieldProps("ssm_number")}
                />
                <Form.Control.Feedback
                  type="invalid"
                  className="text-end text-light"
                >
                  {formik.errors.ssm_number}
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="my-3">
                <Form.Label className="fw-bolder mb-0 lh-1 text-dark">
                  Company Name{" "}
                  {formik.values.dealership_type === "Company" && <sup>*</sup>}
                </Form.Label>
                <Form.Control
                  type="text"
                  name="company_name"
                  placeholder="Your company"
                  isInvalid={
                    formik.touched.company_name && formik.errors.company_name
                  }
                  {...formik.getFieldProps("company_name")}
                />
                <Form.Control.Feedback
                  type="invalid"
                  className="text-end text-light"
                >
                  {formik.errors.company_name}
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="my-3">
                <Form.Label className="fw-bolder mb-0 lh-1 text-dark">
                  Phone <sup>*</sup>
                </Form.Label>
                <InputMask
                  className={`form-control ${
                    formik.touched.phone && formik.errors.phone
                      ? "is-invalid"
                      : ""
                  }`}
                  name="phone"
                  type="text"
                  mask="60 99 999 9999 999"
                  maskChar=" "
                  onChange={(e) => {
                    formik.setFieldValue(
                      "phone",
                      e.target.value.replace(/\s/g, "")
                    );
                    if (formik.touched.phone && formik.errors.phone)
                      formik.setFieldError(
                        "phone",
                        "phone number is not valid"
                      );
                  }}
                />
                <Form.Control.Feedback
                  type="invalid"
                  className="text-end text-light"
                >
                  {" "}
                  {formik.errors.phone}
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="my-3">
                <Form.Label className="fw-bolder mb-0 lh-1 text-dark">
                  Line 1<sup>*</sup>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="line_1"
                  placeholder="line 1"
                  isInvalid={formik.touched.line_1 && formik.errors.line_1}
                  {...formik.getFieldProps("line_1")}
                />
                <Form.Control.Feedback
                  type="invalid"
                  className="text-end text-light"
                >
                  {formik.errors.line_1}
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="my-3">
                <Form.Label className="fw-bolder mb-0 lh-1 text-dark">
                  Line 2<sup>*</sup>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="line_2"
                  placeholder="line 2"
                  isInvalid={formik.touched.line_2 && formik.errors.line_2}
                  {...formik.getFieldProps("line_2")}
                />
                <Form.Control.Feedback
                  type="invalid"
                  className="text-end text-light"
                >
                  {formik.errors.line_2}
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="my-3">
                <Form.Label className="fw-bolder mb-0 lh-1 text-dark">
                  Postcode<sup>*</sup>
                </Form.Label>
                <Form.Control
                  type="number"
                  name="postcode"
                  placeholder="11223"
                  isInvalid={formik.touched.postcode && formik.errors.postcode}
                  {...formik.getFieldProps("postcode")}
                />
                <Form.Control.Feedback
                  type="invalid"
                  className="text-end text-light"
                >
                  {formik.errors.postcode}
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="my-3">
                <Form.Label className="fw-bolder mb-0 lh-1 text-dark">
                  Area<sup>*</sup>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="area"
                  placeholder="Area"
                  isInvalid={formik.touched.area && formik.errors.area}
                  {...formik.getFieldProps("area")}
                />
                <Form.Control.Feedback
                  type="invalid"
                  className="text-end text-light"
                >
                  {formik.errors.area}
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="my-3">
                <Form.Label className="fw-bolder mb-0 lh-1 text-dark">
                  State<sup>*</sup>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="state"
                  placeholder="State"
                  isInvalid={formik.touched.state && formik.errors.state}
                  {...formik.getFieldProps("state")}
                />
                <Form.Control.Feedback
                  type="invalid"
                  className="text-end text-light"
                >
                  {formik.errors.state}
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="my-3">
                <Form.Label className="fw-bolder mb-0 lh-1 text-dark">
                  Country<sup>*</sup>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="country"
                  placeholder="Country"
                  isInvalid={formik.touched.country && formik.errors.country}
                  {...formik.getFieldProps("country")}
                />
                <Form.Control.Feedback
                  type="invalid"
                  className="text-end text-light"
                >
                  {formik.errors.country}
                </Form.Control.Feedback>
              </Form.Group>

              <div className="d-grid my-4">
                <Button variant="primary text-white" size="lg" type="submit">
                  Register
                </Button>
              </div>

              <Form.Group>
                <p className="text-center mt-3 text-dark fw-bolder">
                  Already have an account?{" "}
                  <small
                    onClick={() => {
                      formik.resetForm();
                      router.push({ pathname: "/" });
                    }}
                    className="text-dark cursor-pointer text-decoration-underline"
                  >
                    Sign in
                  </small>
                </p>
              </Form.Group>
            </Form>
          </Card>
        </Col>
      </Row>

      <Backdrop show={true} closeBackdrop={() => null} />
      <Row></Row>
    </Container>
  );
}
